<template>
  <span>
    <header>
      <nav class="navbar navbar-expand-md fixed-top class_box_shadow bck-faded">
        <a class="navbar-brand" href="/">
          <img alt="home to live" title="home to live" src="/pub/vu/assets/images/hometolive_Logo.png" height="54px">
        </a>
        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarCollapse"
          aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <i class="navbar-toggler-icon fa-bars"></i>

        </button>

        <div class="navbar-collapse collapse" id="navbarCollapse">
          <ul class="row row justify-content-center navbar-nav mr-auto top-navlinks">

            <li class="nav-item"  :class="{ 'nav-item active': $route.path === '/' }">
              <a class="nav-link" href="/" @click="getActiveNavLink($event)">Home </a>
            </li>
            <li class="nav-item" :class="{ 'nav-item active': $route.path === '/contactus' }" >
              <a class="nav-link" href="/pub/vu/#/contactus" @click="getActiveNavLink($event)">Contact Us </a>
            </li>
          </ul>

        </div>

      </nav>
    </header>

    <router-view></router-view>


  </span>
</template>

<script>
import Routes from "./router";
//import $ from "jquery";

export default {
  name: "App",

  data() {
    return {
      Routes,
    };
  },

  methods: {
    updateYear: function () {
      this.copyrightYear = new Date().getFullYear();
      return this.copyrightYear
    },
    /**
     * Update the theme of the footer based on the currently active view
     */
     getActiveNavLink(event) {     
      this.$el.querySelector('.active').classList.remove("active");
      event.target.parentElement.classList.add("active");            
    }
  },

  mounted() {
    //this.updateTheme();
    //document.querySelector('#app .logo').style.marginTop = "0px"
  },

  updated() {
    this.updateTheme();
  },
};
</script>

<style scoped>
* {
  font-family: 'asap', sans-serif;
}

body,
html,
main,
#myCarousel,
.carousel-inner,
.carousel-item,
.container {
  height: 100%;
}

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

.b-example-divider {
  height: 3rem;
  background-color: rgba(0, 0, 0, .1);
  border: solid rgba(0, 0, 0, .15);
  border-width: 1px 0;
  box-shadow: inset 0 .5em 1.5em rgba(0, 0, 0, .1), inset 0 .125em .5em rgba(0, 0, 0, .15);
}

.b-example-vr {
  flex-shrink: 0;
  width: 1.5rem;
  height: 100vh;
}

.bi {
  vertical-align: -.125em;
  fill: currentColor;
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}


.class_box_shadow {
  margin: auto;
  text-align: left;
  background-image: url('/images/top.jpg');
  background-repeat: no-repeat;
  background-position: left;

  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZlZmNlYSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNlN2U4ZDciIHN0b3Atb3BhY2l0eT0iMC43Ii8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=);
  background: -moz-linear-gradient(top, rgba(254, 252, 234, 1) 0%, rgba(231, 232, 215, 0.7) 100%);
  /* background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(254,252,234,1)), color-stop(100%,rgba(231,232,215,0.7))); */
  /* background: -webkit-linear-gradient(top, rgba(254,252,234,1) 0%,rgba(231,232,215,0.7) 100%); */
  background: -o-linear-gradient(top, rgba(254, 252, 234, 1) 0%, rgba(231, 232, 215, 0.7) 100%);
  background: -ms-linear-gradient(top, rgba(254, 252, 234, 1) 0%, rgba(231, 232, 215, 0.7) 100%);
  background: linear-gradient(top, rgba(254, 252, 234, 1) 0%, rgba(231, 232, 215, 0.7) 100%);
  -ms-filter: progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#000000') progid:DXImageTransform.Microsoft.gradient(startColorstr='#fefcea', endColorstr='#b3e7e8d7', GradientType=0);
  filter: progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color='#000000') progid:DXImageTransform.Microsoft.gradient(startColorstr='#fefcea', endColorstr='#b3e7e8d7', GradientType=0);


}

.top-navlinks li a {
  color: #fff;
}

.bck-faded {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
}

.carousel-indicators {
  top: 60%;
}

@media (max-width: 768px) {
  .carousel-item {
    height: 100%;
  }

  .carousel-item>img {
    height: 100%;
  }

  .h1,
  h1 {
    font-size: 1.5rem;
  }

  .carousel-caption {
    bottom: 127px;
  }

  .fa-navicon:before,
  .fa-reorder:before,
  .fa-bars:before {
    content: "Menu";
    color: white;
    border: 1px solid white;
    padding: 8px;
    right: 27px;
    position: relative;
  }

  .carousel-indicators {
    bottom: 1%;
    top: auto;
  }
}


@media (max-width: 1131px) and (min-width: 768px) {
  .col-4 {
    -ms-flex: 0 0 45.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
    font-size: 80%;
  }
}

@media (min-width: 768px) {
  .carousel-indicators {
    top: 76%;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }

  .top-navlinks li a {
    margin: auto;
  }

  .navbar-expand-md .navbar-nav {
    margin: auto;
    width: 50%;
  }

  .navbar-expand-md .navbar-nav a:hover {

    color: #fff;
  }

  .top-navlinks li {
    margin-right: 5px;
    max-width: none;
    padding: 0;
    width: auto;
  }

  .top-navlinks li.active a {
    font-weight: bold;
  }

  #navbarCollapse {
    left: 0;
    position: absolute;
    width: 100%;
  }

  .nav-link {
    text-align: center;
  }

  .navbar-nav {
    padding-left: 17px;
  }

  .carousel-item>img {
    position: absolute;
    top: 0;
    left: 0;
    min-width: 100%;
    height: 100%;
  }



}

.carousel-item .container {
  max-width: 100%;
  padding: 0;
}

.carousel-item .container img {
  width: 100%;
}

.carousel-caption {
  z-index: 1;
  text-align: center !important;
  height: 18rem;
}

ol,
ul {
  padding-left: 0;
}

ul li li {
  font-size: smaller;
}

ul ul {
  padding: 5px;
}

.carousel-control-next {
  width: 30px;
  height: 0;
  border-top: 100px solid transparent;
  border-left: 50px solid rgba(199, 161, 72, 0.74);
  border-bottom: 100px solid transparent;
  top: 42%;
  opacity: 0.8;
  transition: opacity .15s ease;
}

.carousel-control-prev {
  width: 30px;
  height: 0;
  border-top: 150px solid transparent;
  border-right: 50px solid rgba(199, 161, 72, 0.74);
  border-bottom: 150px solid transparent;
  top: 42%;
  opacity: 0.8;
  transition: opacity .15s ease;
}

.carousel-control-next {
  width: 30px;
  height: 0;
  border-top: 150px solid transparent;
  border-left: 50px solid rgba(199, 161, 72, 0.74);
  border-bottom: 150px solid transparent;
  top: 42%;
  opacity: 0.8;
  transition: opacity .15s ease;
}

.carousel-item>img {
  width: 110%;
}</style>
